import { Spinner } from 'design-system/react';

import { useSimulationEarnings, useDocumentTitle } from '../../hooks';

import { CountdownClock } from '../atoms';
import { AccumulatedValueChart, EarningsRateChart } from '../molecules';
import { Page } from '../organisms';

export function AccumulatedValuePage() {
  const { data, isLoading } = useSimulationEarnings();

  // Update browser tab title
  useDocumentTitle('Value Chart');

  return (
    <Page title={null} fullWidth>
      <CountdownClock className="text-[32pt] my-[1ex]" />
      <div className="flex flex-col w-full items-center gap-8">
        {isLoading && <Spinner size="lg" />}
        {data && (
          <>
            <AccumulatedValueChart chart_data={data.chart_data} />
            <h2 className="text-xl font-semibold text-text-primary">Earnings Rate</h2>
            <EarningsRateChart chart_data={data.rate_data} />
          </>
        )}
      </div>
    </Page>
  );
}
